export default {
  api: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    cryptoKey: process.env.REACT_APP_CRYPTO_KEY,
    chatbotHost: process.env.REACT_APP_CHATBOT_HOST,
  },
}



// WEBPACK FOOTER //
// src/config/index.js